import { Injectable } from '@angular/core';
import { ServiceBase } from './servicebase.service';
import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService extends ServiceBase {

  public hasAlertSubscription(alertType: string, alertTargetId?: string): Observable<ServerModels.CrimeGunAlertViewModel> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let options = {
      headers: headersObj,
      params: {
        'alertType': alertType,
        'alertTargetId': alertTargetId || ''
      }
    };

    return this.http.get<ServerModels.CrimeGunAlertViewModel>(`${this.apiRoot}/api/Alerts/HasAlertSubscription`, options).pipe(catchError(this.swallowError<any>('hasAlertSubscription', 'defaultMsg', null, null)));
  }

  public subscribeAlert(crimegunAlert: ServerModels.CrimeGunAlertViewModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiRoot}/api/Alerts/SubscribeAlert`, crimegunAlert, this.httpOptions).pipe(catchError(this.throwError<any>('subscribeAlert', 'defaultMsg', null, null)));
  }

  public unsubscribeAlert(crimegunAlert: ServerModels.CrimeGunAlertViewModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiRoot}/api/Alerts/UnsubscribeAlert`, crimegunAlert, this.httpOptions).pipe(catchError(this.throwError<any>('unsubscribeAlert', 'defaultMsg', null, null)));
  }

  public GetCrimeGunAlertsByUser(): Observable<ServerModels.CrimeGunCaseAlertsViewModel[]> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let options = {
      headers: headersObj
    };

    return this.http.get<ServerModels.CrimeGunCaseAlertsViewModel[]>(`${this.apiRoot}/api/Alerts/GetCrimeGunAlertsByUser`, options).pipe(catchError(this.swallowError<any>('GetCrimeGunAlertsByUser', 'defaultMsg', null, null)));
  }

  public DeleteCrimeGunCaseAlertByID(crimegunGunAlertId: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiRoot}/api/Alerts/DeleteCrimeGunCaseAlertByID`, { 'crimegunGunAlertId': crimegunGunAlertId }, this.httpOptions).pipe(catchError(this.throwError<any>('DeleteCrimeGunCaseAlertByID', 'defaultMsg', null, null)));
  }

  public AddOrUpdateCrimeGunCaseAlert(crimegunGunAlert: ServerModels.ENESS_AlertsUserRequest_CrimeGunCases): Observable<ServerModels.CrimeGunCaseAlertsViewModel> {
    if (!crimegunGunAlert.AlertsUserRequest_CrimeGunCasesID) crimegunGunAlert.AlertsUserRequest_CrimeGunCasesID = 0;
    if (crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesFieldDivisionGroups) crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesFieldDivisionGroups.forEach(g => g.AlertsUserRequest_CrimeGunCasesID = g.AlertsUserRequest_CrimeGunCasesID ? g.AlertsUserRequest_CrimeGunCasesID : 0);
    if (crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesCounties) crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesCounties.forEach(c => c.AlertsUserRequest_CrimeGunCasesID = c.AlertsUserRequest_CrimeGunCasesID ? c.AlertsUserRequest_CrimeGunCasesID : 0);
    if (crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesAgencies) crimegunGunAlert.ENESS_XREF_AlertCrimeGunCasesAgencies.forEach(a => a.AlertsUserRequest_CrimeGunCasesID = a.AlertsUserRequest_CrimeGunCasesID ? a.AlertsUserRequest_CrimeGunCasesID : 0);
    if (!crimegunGunAlert.CreatedOn) crimegunGunAlert.CreatedOn = new Date();
    return this.http.post<ServerModels.CrimeGunCaseAlertsViewModel>(`${this.apiRoot}/api/Alerts/AddOrUpdateCrimeGunCaseAlert`, crimegunGunAlert, this.httpOptions).pipe(catchError(this.throwError<any>('AddOrUpdateCrimeGunCaseAlert', 'defaultMsg', null, null)));
  }

  public GetCrimeGunAlertsById(alertId: number): Observable<ServerModels.ENESS_AlertsUserRequest_CrimeGunCases> {
    return this.http.get<ServerModels.ENESS_AlertsUserRequest_CrimeGunCases>(`${this.apiRoot}/api/Alerts/GetCrimeGunAlertsById?alertId=${alertId}`, this.httpOptions).pipe(catchError(this.throwError<any>('GetCrimeGunAlertsById', 'defaultMsg', null, null)));
  }
}
